import "./App.css";
import React, { useEffect } from "react";

import {
  getForwardTargetUrl,
  replaceBrowsingContext,
} from "./boatparkForward";

import "./stylesheets/main.css";

function App() {
  useEffect(() => {
    replaceBrowsingContext(getForwardTargetUrl(window.location.pathname));
  }, []);

  return null;
}

export default App;
